import React from 'react';
import CentralizedSpinner from 'components/CentralizedSpinner';
import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import useImages from 'hooks/Meteorology/Weather/SeasonalForecast/useImages';
import './index.scss';

export default function MeteorologyWeatherImageDisplay() {
  const {
    image, queryError, onRetry, loading,
  } = useImages();

  return (
    <div className="seasonal-forecast-image">
      {loading && <CentralizedSpinner />}
      {!loading && queryError && (
        <QueryErrorState
          title={queryError.data}
          message={queryError.description}
          onRetry={onRetry}
        />
      )}
      {!loading && !queryError && (
        <EnlargeableImage
          src={`data:image/png;base64,${image}`}
          className={`${image ? '' : 'no-image'}`}
        />
      )}
    </div>
  );
}
